import api from "@/lib/api";

const SESSION_KEY = "wb_sess";

function getSessionId() {
  let s = localStorage.getItem(SESSION_KEY);
  if (!s) {
    s = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

const send = (event) => {
  // fire-and-forget — never block UI
  try {
    api.post("/track", event).catch(() => {});
  } catch {
    /* ignore */
  }
};

export function trackPageView(path) {
  send({
    type: "page_view",
    path,
    session_id: getSessionId(),
    referrer: document.referrer || null,
    user_agent: navigator.userAgent.slice(0, 200),
  });
}

export function trackClick(target, path = window.location.pathname) {
  send({ type: "click", path, target, session_id: getSessionId() });
}

export function trackEvent(type, target, path = window.location.pathname) {
  send({ type, path, target, session_id: getSessionId() });
}
